import moment from 'moment';

export function cwrite(type, loc) {
    return {
        msg: (msg) => {
            const
            timeStamp = `[${moment().hour()}:${moment().minute()}:${moment().second()}] `,
            pre = '[EXTERNAL RESOURCE]';
            var _msg = `${timeStamp}${pre} `;

            if(loc != null && loc !== '') _msg += `<${loc}> `;
            _msg += `${msg}`;

            switch(type) {
                case 'error':
                    console.error(_msg);
                    break;
                case 'warning':
                    console.warn(_msg);
                    break;
                default:
                    conole.log(_msg);
            }
        }
    }
}
